import * as BREAKPOINTS from '@zola/zola-ui/src/lib/ui/breakpoints';

import { PartnerTileProps } from './PartnerTile';
import { StyledDescription } from './PartnerTile.styles';

import PressMobile from '../../../../../public/static-preauth/images/ContactUs/partners/press-mobile.jpg';
import PressMobile2x from '../../../../../public/static-preauth/images/ContactUs/partners/press-mobile@2x.jpg';
import RegistryMobile from '../../../../../public/static-preauth/images/ContactUs/partners/registry-mobile.jpg';
import RegistryMobile2x from '../../../../../public/static-preauth/images/ContactUs/partners/registry-mobile@2x.jpg';
import VendorMobile from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-mobile.jpg';
import VendorMobile2x from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-mobile@2x.jpg';

import PressMobileWebp from '../../../../../public/static-preauth/images/ContactUs/partners/press-mobile.webp';
import PressMobile2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/press-mobile@2x.webp';
import RegistryMobileWebp from '../../../../../public/static-preauth/images/ContactUs/partners/registry-mobile.webp';
import RegistryMobile2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/registry-mobile@2x.webp';
import VendorMobileWebp from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-mobile.webp';
import VendorMobile2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-mobile@2x.webp';

import PressDesktop from '../../../../../public/static-preauth/images/ContactUs/partners/press-desktop.jpg';
import PressDesktop2x from '../../../../../public/static-preauth/images/ContactUs/partners/press-desktop@2x.jpg';
import RegistryDesktop from '../../../../../public/static-preauth/images/ContactUs/partners/registry-desktop.jpg';
import RegistryDesktop2x from '../../../../../public/static-preauth/images/ContactUs/partners/registry-desktop@2x.jpg';
import VendorDesktop from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-desktop.jpg';
import VendorDesktop2x from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-desktop@2x.jpg';

import PressDesktopWebp from '../../../../../public/static-preauth/images/ContactUs/partners/press-desktop.webp';
import PressDesktop2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/press-desktop@2x.webp';
import RegistryDesktopWebp from '../../../../../public/static-preauth/images/ContactUs/partners/registry-desktop.webp';
import RegistryDesktop2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/registry-desktop@2x.webp';
import VendorDesktopWebp from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-desktop.webp';
import VendorDesktop2xWebp from '../../../../../public/static-preauth/images/ContactUs/partners/vendor-desktop@2x.webp';

export const tilesContent: PartnerTileProps[] = [
  {
    images: {
      webp: [
        {
          url: VendorMobileWebp,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: VendorMobile2xWebp,
        },
        {
          url: VendorDesktopWebp,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: VendorDesktop2xWebp,
        },
      ],
      jpg: [
        {
          url: VendorMobile,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: VendorMobile2x,
        },
        {
          url: VendorDesktop,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: VendorDesktop2x,
        },
      ],
    },
    featuredImageSrc: VendorDesktop,
    imgAlt: 'florist planning flower arrangements',
    hed: 'Wedding vendors and professionals',
    dek: (
      <StyledDescription>
        Want to publish a listing on Zola? Reach out to{' '}
        <a href="mailto:weddingvendors@zola.com">weddingvendors@zola.com</a>.
      </StyledDescription>
    ),
    link: {
      href: 'https://welcome.zola.com/for-vendors/',
      text: 'Request to join Zola',
    },
  },
  {
    images: {
      webp: [
        {
          url: RegistryMobileWebp,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: RegistryMobile2xWebp,
        },
        {
          url: RegistryDesktopWebp,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: RegistryDesktop2xWebp,
        },
      ],
      jpg: [
        {
          url: RegistryMobile,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: RegistryMobile2x,
        },
        {
          url: RegistryDesktop,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: RegistryDesktop2x,
        },
      ],
    },
    featuredImageSrc: RegistryDesktop,
    imgAlt: '',
    hed: 'Sell your products on Zola registry',
    dek: (
      <StyledDescription>
        Interested in selling your products with us? Get in touch at{' '}
        <a href="mailto:vendors@zola.com">vendors@zola.com</a>.
      </StyledDescription>
    ),
    link: {
      href: '/faq/category/115000342852-for-registry-product-vendors',
      text: 'Learn more',
    },
  },
  {
    images: {
      webp: [
        {
          url: PressMobileWebp,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: PressMobile2xWebp,
        },
        {
          url: PressDesktopWebp,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: PressDesktop2xWebp,
        },
      ],
      jpg: [
        {
          url: PressMobile,
          maxBreakpoint: BREAKPOINTS.SCREEN_XS_MAX.toString(),
          url2x: PressMobile2x,
        },
        {
          url: PressDesktop,
          minBreakpoint: BREAKPOINTS.SCREEN_SM.toString(),
          url2x: PressDesktop2x,
        },
      ],
    },
    featuredImageSrc: PressDesktop,
    imgAlt: 'wedding dresses with zola logo in foreground',
    hed: 'Press and marketing',
    dek: (
      <StyledDescription>
        Have media requests or partnership ideas? Send them to{' '}
        <a href="mailto:marketing@zola.com">marketing@zola.com</a>.
      </StyledDescription>
    ),
  },
];
